/**
 * ### 信望愛希臘文內碼 (ASCII) → Unicode，對應 PHP gcode($itxt, 2)
 * 例 `to; pneu'ma mh; sbevnnute,` → `τὸ πνεῦμα μὴ σβέννυτε,`
 * - 重音輸出的是 oxia 版 (έ U+1F73)，與 FHL 資料庫、ssn.php 的 Unicode 查詢一致；鍵盤打的是 tonos (U+03AD)
 * - 來源 VirtualApi/api_php/gcode2.js；已用 bible_fhlwh.sqlite 全新約 7958 節與 qsb.php (fhlwh) 比對，除換行位置外全同
 * - 測試 tests/gcode2.test.js (npm test)
 */
function replaceAllLiteral(text, search, replacement) {
    return text.split(search).join(replacement);
}
function replaceByTable(text, fromList, toList) {
    let out = text;
    for (let i = 0; i < fromList.length; i += 1) {
        out = replaceAllLiteral(out, fromList[i], toList[i]);
    }
    return out;
}

const orgb = [
    'Aj/', 'Hj/', 'Wj/', 'a$/', 'h$/', 'w$/',
    'AJ/', 'HJ/', 'WJ/', 'a%/', 'h%/', 'w%/',
    'A]/', 'H]/', 'W]/', 'a</', 'h</', 'w</',
    'A^/', 'H^/', 'W^/', 'a@/', 'h@/', 'w@/',
    'A[/', 'H[/', 'W[/', 'a~/', 'h~/', 'w~/',
    'A&/', 'H&/', 'W&/', 'a!/', 'h!/', 'w!/',
    'A\\/', 'H\\/', 'W\\/', 'a*/', 'h*/', 'w*/',
    'A|/', 'H|/', 'W|/', 'a+/', 'h+/', 'w+/',
    'a;/', 'h;/', 'w;/',
    'A/', 'H/', 'W/', 'a/', 'h/', 'w/',
    "a'/", "h'/", "w'/", "av/", "hv/", "wv/",
    'A&', 'E&', 'H&', 'I&', 'O&', 'U&', 'W&', 'a!', 'e!', 'h!', 'i!', 'o!', 'u!', 'w!',
    "a'", "h'", "i'", "u'", "w'",
    'a;', 'e;', 'h;', 'i;', 'o;', 'u;', 'w;',
    'i>', 'u>', 'i?', 'u?',
    'AJ', 'EJ', 'HJ', 'IJ', 'OJ', 'UJ', 'WJ', 'RJ', 'a%', 'e%', 'h%', 'i%', 'o%', 'u%', 'w%', 'r%',
    'A[', 'E[', 'H[', 'I[', 'O[', 'U[', 'W[', 'a~', 'e~', 'h~', 'i~', 'o~', 'u~', 'w~',
    'A\\', 'E\\', 'H\\', 'I\\', 'O\\', 'U\\', 'W\\', 'a*', 'e*', 'h*', 'i*', 'o*', 'u*', 'w*',
    'A]', 'E]', 'H]', 'I]', 'O]', 'U]', 'W]', 'a<', 'e<', 'h<', 'i<', 'o<', 'u<', 'w<',
    'A^', 'E^', 'H^', 'I^', 'O^', 'U^', 'W^', 'a@', 'e@', 'h@', 'i@', 'o@', 'u@', 'w@',
    'Aj', 'Ej', 'Hj', 'Ij', 'Oj', 'Wj', 'a$', 'e$', 'h$', 'i$', 'o$', 'u$', 'w$',
    'Aj', 'Ej', 'Hj', 'Ij', 'Oj', 'Wj',
    'A;', 'E;', 'H;', 'I;', 'O;', 'W;',
    'av', 'ev', 'hv', 'iv', 'ov', 'uv', 'wv',
    'A|', 'E|', 'H|', 'I|', 'O|', 'U|', 'W|', 'a+', 'e+', 'h+', 'i+', 'o+', 'u+', 'w+',
    'i:', 'u:'
];
const orga = [
    'A$/', 'H$/', 'W$/', 'aj/', 'hj/', 'wj/',
    'A%/', 'H%/', 'W%/', 'aJ/', 'hJ/', 'wJ/',
    'A</', 'H</', 'W</', 'a]/', 'h]/', 'w]/',
    'A@/', 'H@/', 'W@/', 'a^/', 'h^/', 'w^/',
    'A~/', 'H~/', 'W~/', 'a[/', 'h[/', 'w[/',
    'A!/', 'H!/', 'W!/', 'a&/', 'h&/', 'w&/',
    'A*/', 'H*/', 'W*/', 'a\\/', 'h\\/', 'w\\/',
    'A+/', 'H+/', 'W+/', 'a|/', 'h|/', 'w|/',
    'a;/', 'h;/', 'w;/',
    'A/', 'H/', 'W/', 'a/', 'h/', 'w/',
    'av/', 'hv/', 'wv/', "a'/", "h'/", "w'/",
    'A!', 'E!', 'H!', 'I!', 'O!', 'U!', 'W!', 'a&', 'e&', 'h&', 'i&', 'o&', 'u&', 'w&',
    "a'", "h'", "i'", "u'", "w'",
    'a;', 'e;', 'h;', 'i;', 'o;', 'u;', 'w;',
    'i>', 'u>', 'i?', 'u?',
    'A%', 'E%', 'H%', 'I%', 'O%', 'U%', 'W%', 'R%', 'aJ', 'eJ', 'hJ', 'iJ', 'oJ', 'uJ', 'wJ', 'rJ',
    'A~', 'E~', 'H~', 'I~', 'O~', 'U~', 'W~', 'a[', 'e[', 'h[', 'i[', 'o[', 'u[', 'w[',
    'A*', 'E*', 'H*', 'I*', 'O*', 'U*', 'W*', 'a\\', 'e\\', 'h\\', 'i\\', 'o\\', 'u\\', 'w\\',
    'A<', 'E<', 'H<', 'I<', 'O<', 'U<', 'W<', 'a]', 'e]', 'h]', 'i]', 'o]', 'u]', 'w]',
    'A@', 'E@', 'H@', 'I@', 'O@', 'U@', 'W@', 'a^', 'e^', 'h^', 'i^', 'o^', 'u^', 'w^',
    'A$', 'E$', 'H$', 'I$', 'O$', 'W$', 'aj', 'ej', 'hj', 'ij', 'oj', 'uj', 'wj',
    'Aj', 'Ej', 'Hj', 'Ij', 'Oj', 'Wj',
    'A;', 'E;', 'H;', 'I;', 'O;', 'W;',
    'av', 'ev', 'hv', 'iv', 'ov', 'uv', 'wv',
    'A+', 'E+', 'H+', 'I+', 'O+', 'U+', 'W+', 'a|', 'e|', 'h|', 'i|', 'o|', 'u|', 'w|',
    'i:', 'u:'
];
const AD = [
    '"', '#', '{', '}',
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '`',
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'w', 'x', 'y', 'z'
];
const UAD = [
    'ς', '᾽', '·', ';',
    'Α', 'Β', 'Χ', 'Δ', 'Ε', 'Φ', 'Γ', 'Η', 'Ι', 'Κ', 'Λ', 'Μ', 'Ν', 'Ο', 'Π', 'Θ', 'Ρ', 'Σ', 'Τ', 'Υ', '´', 'Ω', 'Ξ', 'Ψ', 'Ζ', '`',
    'α', 'β', 'χ', 'δ', 'ε', 'φ', 'γ', 'η', 'ι', 'κ', 'λ', 'μ', 'ν', 'ο', 'π', 'θ', 'ρ', 'σ', 'τ', 'υ', 'ω', 'ξ', 'ψ', 'ζ'
];
const uorg = [
    'ᾈ', 'ᾘ', 'ᾨ', 'ᾀ', 'ᾐ', 'ᾠ',
    'ᾉ', 'ᾙ', 'ᾩ', 'ᾁ', 'ᾑ', 'ᾡ',
    'ᾊ', 'ᾚ', 'ᾪ', 'ᾂ', 'ᾒ', 'ᾢ',
    'ᾋ', 'ᾛ', 'ᾫ', 'ᾃ', 'ᾓ', 'ᾣ',
    'ᾌ', 'ᾜ', 'ᾬ', 'ᾄ', 'ᾔ', 'ᾤ',
    'ᾍ', 'ᾝ', 'ᾭ', 'ᾅ', 'ᾕ', 'ᾥ',
    'ᾎ', 'ᾞ', 'ᾮ', 'ᾆ', 'ᾖ', 'ᾦ',
    'ᾏ', 'ᾟ', 'ᾯ', 'ᾇ', 'ᾗ', 'ᾧ',
    'ᾲ', 'ῂ', 'ῲ',
    'ᾼ', 'ῌ', 'ῼ', 'ᾳ', 'ῃ', 'ῳ',
    'ᾴ', 'ῄ', 'ῴ', 'ᾷ', 'ῇ', 'ῷ',
    'Ἅ', 'Ἕ', 'Ἥ', 'Ἵ', 'Ὅ', 'Ὕ', 'Ὥ', 'ἅ', 'ἕ', 'ἥ', 'ἵ', 'ὅ', 'ὕ', 'ὥ',
    'ᾶ', 'ῆ', 'ῖ', 'ῦ', 'ῶ',
    'ὰ', 'ὲ', 'ὴ', 'ὶ', 'ὸ', 'ὺ', 'ὼ',
    'ϊ', 'ϋ', 'ΐ', 'ΰ',
    'Ἁ', 'Ἑ', 'Ἡ', 'Ἱ', 'Ὁ', 'Ὑ', 'Ὡ', 'Ῥ', 'ἁ', 'ἑ', 'ἡ', 'ἱ', 'ὁ', 'ὑ', 'ὡ', 'ῥ',
    'Ἄ', 'Ἔ', 'Ἤ', 'Ἴ', 'Ὄ', '὜', 'Ὤ', 'ἄ', 'ἔ', 'ἤ', 'ἴ', 'ὄ', 'ὔ', 'ὤ',
    'Ἆ', '἞', 'Ἦ', 'Ἶ', '὎', '὞', 'Ὦ', 'ἆ', '἖', 'ἦ', 'ἶ', '὆', 'ὖ', 'ὦ',
    'Ἂ', 'Ἒ', 'Ἢ', 'Ἲ', 'Ὂ', '὚', 'Ὢ', 'ἂ', 'ἒ', 'ἢ', 'ἲ', 'ὂ', 'ὒ', 'ὢ',
    'Ἃ', 'Ἓ', 'Ἣ', 'Ἳ', 'Ὃ', 'Ὓ', 'Ὣ', 'ἃ', 'ἓ', 'ἣ', 'ἳ', 'ὃ', 'ὓ', 'ὣ',
    'Ἀ', 'Ἐ', 'Ἠ', 'Ἰ', 'Ὀ', 'Ὠ', 'ἀ', 'ἐ', 'ἠ', 'ἰ', 'ὀ', 'ὐ', 'ὠ',
    'Ἀ', 'Ἐ', 'Ἠ', 'Ἰ', 'Ὀ', 'Ὠ',
    'Ὰ', 'Ὲ', 'Ὴ', 'Ὶ', 'Ὸ', 'Ὼ',
    'ά', 'έ', 'ή', 'ί', 'ό', 'ύ', 'ώ',
    'Ἇ', '἟', 'Ἧ', 'Ἷ', '὏', 'Ὗ', 'Ὧ', 'ἇ', '἗', 'ἧ', 'ἷ', '὇', 'ὗ', 'ὧ',
    'ῒ', 'ῢ'
];

/** greekToFhlCode (反向) 用 */
export const GCODE2_TABLES = Object.freeze({ orga, orgb, uorg, AD, UAD })

/**
 * 對應 PHP: gcode($itxt, 2)
 * @param {string} input
 * @returns {string}
 */
export function gcode_2(input) {
    let itxt = input == null ? '' : String(input);
    if (itxt.length === 0) return itxt;

    // bible_fhlwh.sqlite 的 txt 有 2 個字元是當初編碼轉換時弄錯的 (原本是單一 byte 的縮寫)
    // 由與 qsb.php 全新約比對推得：U+0358 (o͘) 是 u，U+1E73 (ṳ) 是 ii (只出現在 2 Tim 2:16)
    itxt = itxt.replace(/\u0358/g, 'u').replace(/\u1e73/g, 'ii');

    // PHP:
    // $txt=preg_replace("/s([-\r\n,.:;}{) ])/","{$ns}\\1",$itxt);
    // $txt=preg_replace('/s$/',$ns,$txt);
    const txt = itxt
        .replace(/s([-\r\n,.:;}{) ])/g, '"$1')
        .replace(/s$/g, '"');

    let ntxt = replaceByTable(txt, orga, uorg);
    ntxt = replaceByTable(ntxt, orgb, uorg);
    // PHP 沒有把落單的 v ; j J 另外轉換 (照原樣輸出)，已與 qsb.php 全新約比對
    ntxt = replaceByTable(ntxt, AD, UAD);
    return ntxt;
}
